import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, FormControl, GlobalStyles, IconButton, InputLabel, MenuItem, Select, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../../../assets/images/runner-logo.png';
import { Types as UserTypes } from '../../../sagas/users';

const CustomAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: `${theme.palette.primary.main} !important`,
  boxShadow: 'none',
  height: '60px',
  zIndex: 1201,
}));


const CustomToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: '60px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 2),
}));

const LogoImage = styled('img')({
  height: '40px',
  width: 'auto',
});

const selectStyle = {
  color: 'white',
  '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
  '.MuiSvgIcon-root ': { fill: 'white !important' },
}

const Topbar = ({ onSidebarOpen }) => {
  const dispatch = useDispatch();

  const { offices } = useSelector(state => state.authentication.user);
  const { officeId } = useSelector(state => state.authentication);

  const handleSelectOffice = (event) => {
    dispatch({ type: UserTypes.requestSelectOffice, payload: event.target.value });
  }

  return (
    <>
      <GlobalStyles
        styles={{
          'html, body, #root': {
            height: '100%',
            margin: 0,
            padding: 0,
          },
          '.MuiPaper-root': {
            boxShadow: 'none !important', // Força a remoção da sombra
          },
        }}
      />

      <CustomAppBar position="fixed">
        <CustomToolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              color="inherit"
              onClick={onSidebarOpen}
              edge="start"
              sx={{
                mr: 2,
                display: { xs: 'block', lg: 'none' },
              }}
            >
              <MenuIcon />
            </IconButton>

            <RouterLink to="/">
              <LogoImage src={logo} alt="Logo" />
            </RouterLink>
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel id="office-label" shrink={true} sx={{ color: 'white', '&.Mui-focused': { color: 'white' } }}>Unidade</InputLabel>
              <Select labelId="office-label" label="Unidade" notched={true} onChange={handleSelectOffice} sx={selectStyle} value={officeId}>
                <MenuItem value="">(Selecione)</MenuItem>
                {offices.map((o) => (
                  <MenuItem key={o.id} value={o.id}>
                    {o.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </CustomToolbar>
      </CustomAppBar>
    </>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func.isRequired,
};

export default Topbar;
